import { ArrowBigRight, Building2, MapPin } from 'lucide-react'

function Map() {
    return (

        <section id="contact" className="py-24 px-4 sm:px-6 lg:px-8 bg-gray-200">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-blue-600 font-bold uppercase tracking-wider mb-2 block">Visit Us</span>
            <h2 className="text-4xl font-bold text-blue-900 mb-8 leading-tight">
              Let's Cultivate Your <br/> Vision Together.
            </h2>
             <p className="text-xl text-gray-600 mb-10 leading-relaxed">
              Our factory is open 7 days a week. Drop by for a consultation or explore our sprawling collection of flora.
            </p>
             <div className="space-y-6 mb-10">
                <div className="flex items-start gap-4">
                   <div className="bg-blue-100 p-3 rounded-full text-blue-600"><MapPin className="w-6 h-6" /></div>
                   <div>
                      <h4 className="font-bold text-lg">Address</h4>
                    <p className="text-gray-600">
                      KH. No. 328 Laxmi Garden, Arya Nagar,<br/>
                      Loni  Ghaziabad - 201102 <br/>
                    </p>
                   </div>
                </div>
                <div className="flex items-start gap-4">
                   <div className="bg-blue-100 p-3 rounded-full text-blue-600"><Building2 className="w-6 h-6" /></div>
                   <div>
                      <h4 className="font-bold text-lg">Hours</h4>
                      <p className="text-gray-600">Mon-Sun: 9:00 AM - 7:00 PM</p>
                   </div>
                </div>
             </div>
            <a href="https://www.google.com/maps/dir/?api=1&destination=28.7349560,77.2915086" target="_blank" 
            className="bg-blue-700 text-white px-8 py-4 rounded-full hover:bg-blue-800 transition-all duration-300 hover:scale-105 inline-flex items-center gap-3 font-bold shadow-lg"
            >
              Get Directions <i class="fa-solid fa-arrow-right"></i>{/* <ArrowBigRight /> */}
            </a>
          </div>
          <div className="rounded-[40px] overflow-hidden shadow-2xl h-[500px] relative z-10 border-8 border-stone-100">
           <iframe
        src="https://maps.google.com/maps?q=28.7349560,77.2915086&hl=en&z=14&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        className="filter grayscale-[30%] hover:grayscale-0 transition-all duration-500"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
          </div>
        </div>
      </section>
  )
}

export default Map